module.exports = __webpack_public_path__ + "static/img/smart_guard.beb0b5d4.png";